import {
    ROUTE_FAVORITE,
    ROUTE_FEATURED,
    ROUTE_GAME,
    ROUTE_LOBBY,
} from '@/models/Route';
import { getHostById } from '@/modules/host/slice';
import { getMainLimitRedState } from '@/modules/main/selector';
import { popupSliceActions } from '@/modules/popup/slice';
import { routeSliceActions } from '@/modules/routeController/slice';
import store from '@/store/store';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LocalStorageKey, useLocalStorage } from './storage/useLocalStorage';
const isValidLobbyPath = (path: string) => {
    switch (path) {
        case ROUTE_FEATURED:
        case ROUTE_FAVORITE:
        case ROUTE_LOBBY:
            return true;
        default:
            return false;
    }
};
export const useEnterGame = () => {
    const [lastLobby, setLastLobby] = useLocalStorage(
        LocalStorageKey.LastLobby,
        ROUTE_FEATURED
    );
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const tryEnterGame = (hostId: number): boolean => {
        const state = store.getState();
        const host = getHostById(state, hostId);
        const limitRedByGameType = getMainLimitRedState(state);
        const limitRedByGame = limitRedByGameType.BetRuleByGameType?.find(
            l => l.GameType === host.GameType
        );
        if (host !== undefined) {
            if (host.IsRest) return false;
            else {
                if (!limitRedByGame || limitRedByGame.BetRule.length == 0) {
                    dispatch(popupSliceActions.open('system.error_m226.17'));
                    return false;
                }
                const ll = window.location.pathname;
                if (isValidLobbyPath(ll)) setLastLobby(ll);
                if (hostId) {
                    navigate(`${ROUTE_GAME}/${hostId}`);
                }
            }
        }
        return true;
    };
    const backToLobby = () => {
        let path = ROUTE_FEATURED;
        if (isValidLobbyPath(lastLobby)) path = lastLobby;
        dispatch(routeSliceActions.goto(path));
        // navigate(path);
    };
    return {
        tryEnterGame,
        backToLobby,
    };
};
export type useEnterGameState = ReturnType<typeof useEnterGame>;
